import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import classes from './../TrialstatNoto.module.css';
import InputTextarea from '../UI/Control/InputTextarea';
import InputString from '../UI/Control/InputString';
import MandatoryLabel from '../UI/Control/MandatoryLabel';
import SelectList from '../UI/Control/SelectList';

const FormLibraryTagModal = (props) => {
    const [show, setShow] = useState(false);
    const [defaultTags, setDefaultTags] = useState('');
    const [tags, setTags] = useState('');
    const [sourceTypeId, setSourceTypeId] = useState('-1');
    const [paradigmId, setParadigmId] = useState('-1');
    const [arrSourceType, setSourceType] = useState([]);
    const [arrParadigm, setParadigm] = useState([]);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setDefaultTags(props.defaultTags);
        setTags(props.tags);
        setSourceTypeId('-1');
        setParadigmId('-1');
        setDefaultTags('');
        FillSourceTypesList();
        FillParadigmList();
        fetchDefaultTagsDetails();
        setShow(true);
    };

    const FillSourceTypesList = () => {
        fetch('api/LibraryForms/FillSourceTypesList')
            .then(response => response.json())
            .then(data => {
                setSourceType(data);
            });
    }

    const FillParadigmList = () => {
        fetch('api/LibraryForms/FillParadigmList')
            .then(response => response.json())
            .then(data => {
                setParadigm(data);
            });
    }

    const SaveFormLibraryTag = (event) => {
        let objDefaultTag = document.getElementById('txtDefaultTag');
        //if (objDefaultTag.value.trim() == '') {
        //    alert('Default tags should not be empty.');
        //    objDefaultTag.focus();
        //    return false;
        //}

        let objTags = document.getElementById('txtTags');
        if (objTags.value.trim() == '') {
            alert('Tags should not be empty.');
            objTags.focus();
            return false;
        }

        let model =
        {
            SourceTypeID: sourceTypeId,
            ParadigmID: paradigmId, 
            LibFormID: props.formId,
            Tags: objDefaultTag.value,
            LibraryFormTags: objTags.value
        }

        fetch('api/ServiceCall/SaveFormLibraryTag', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(model)
        }).then(r => r.text()).then(res => {
            let retVal = res.replace(/["']/g, "");
            if (retVal == "1") {
                setShow(false);
                props.fetchEDCFormsLibTag();
            }
            else {
                alert('Tags are not saved, Something went wrong.');
                return false;
            }
        })
        return true;
    };

    const sourceTypeChangeHandler = (e) => {
        setSourceTypeId(e.target.value);
    }

    const paradigmChangeHandler = (e) => {
        setParadigmId(e.target.value);
    }

    const handleDefaultTagsChange = (e) => {
        setDefaultTags(e.target.value);
    }

    const handleTagsChange = (e) => {
        setTags(e.target.value);
    }

    const fetchDefaultTagsDetails = () => {
        fetch('api/LibraryForms/GetDefaultTagsDetails?libFormId=' + props.formId)
            .then(response => response.json())
            .then(data => {
                setSourceTypeId(data.SourceTypeID);
                setParadigmId(data.ParadigmID);
                setDefaultTags(data.Tags);
            });
    }

    return (
        <>
            {props.btn === "true" && props.action === "add" && <Button variant="primary" className="btn btn-success" onClick={handleShow} style={{ float: "right" }}> {props.text}  </Button>}
            {props.btn === "true" && props.action === "edit" && <button className="btn btn-success" type="button" onClick={handleShow}> {props.text} </button>}

            <Modal show={show} onHide={handleClose} dialogClassName={classes.TSModalDailog_Thirteen} animation={false} backdrop="static" style={{marginTop:"10vh", height:"100vh", maxHeight:"100vh"}}>
                <Modal.Header className={classes.modalHeader}>
                    <div style={{ width: "100%" }}>
                        <Modal.Title>{props.header}</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                   
                    <div className="row mt-2">
                        <div className="col-sm-12 form-group">
                            <span style={{ float: "right", color: "red", display: "block" }}> Note : Multiple tags can be separated by a comma (,) </span>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-sm-5 form-group">
                            <label>Source Type :</label>
                            <SelectList id='ddlSourceType' dataSource={arrSourceType} value={sourceTypeId} onChangeHandler={sourceTypeChangeHandler}style={{ marginTop: "7px", marginBottom: "7px" }}/>
                        </div>
                        <div className="col-sm-5 form-group">
                            <label>Paradigm :</label>
                            <SelectList id='ddlParadigm' dataSource={arrParadigm} value={paradigmId} onChangeHandler={paradigmChangeHandler} style={{ marginTop: "7px", marginBottom: "7px" }} />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-sm-12 form-group">
                            <label>Default Tag :</label>
                            <InputString id="txtDefaultTag" maxlength="500" style={{ marginTop: "7px", marginBottom: "7px" }} value={defaultTags} onChangeHandler={handleDefaultTagsChange} />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-sm-12 form-group">
                            <label style={{ marginTop: "10px", marginBottom: "7px" }}>Tag(s) <MandatoryLabel />:</label>
                            <InputTextarea id="txtTags" rows="10" cols="75" maxlength="4000" value={tags} onChangeHandler={handleTagsChange}></InputTextarea>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="" style={{ width: "100%" }}>
                        <Button variant="primary" className="btn btn-danger" onClick={handleClose} style={{ float: "right" }}>
                            Close
                            </Button>
                        {!props.disabled && (props.action == "add" || props.action == "edit") && <Button variant="secondary" className="btn btn-success" onClick={SaveFormLibraryTag} style={{ marginRight: "10px", float: "right" }}> Save </Button>}
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default FormLibraryTagModal;